<form #UpdateForm="ngForm" class="single_import_form">
  <div class="row single_import_row">
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Geography* </div>
        <!-- <mat-form-field > -->
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.geography" [matAutocomplete]="autoGeography" required="true" name="geography"
            #geography="ngModel" (ngModelChange)="applyFilterOnGeography($event)" 
            (keypress)="keyPressAlphaNumeric($event)" maxlength="50" (focus)="selectedGeography()">
          <mat-autocomplete #autoGeography="matAutocomplete" (optionSelected)="selectedGeography()">
            <mat-option *ngFor="let item of searchedGeographies" [value]="item.value">
              {{item.name}}
            </mat-option>
          </mat-autocomplete>
          <div *ngIf="geography.invalid && (geography.dirty || geography.touched)">
            <span class="mat-error custom-mat-error" *ngIf="geography.errors.required">
              Geography is required
            </span>
          </div>
        <!-- </mat-form-field> -->
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Publish Date* </div>
        <!-- <mat-form-field> -->
          <div class="input-group input-group-sm">
            <input matInput [matDatepicker]="picker" (click)="picker.open()" 
              class="form-control form-control-sm border-bottom" id="fromDate" [(ngModel)]="InputModel.publishDate"
              readonly name="PublishDate" #PublishDate="ngModel" required="true">
            <div class="input-group-append">
              <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
            </div>
          </div>
          <mat-datepicker #picker></mat-datepicker>
          <div *ngIf="PublishDate.invalid && (PublishDate.dirty || PublishDate.touched)">
            <span> {{PublishDate.errors|json}}</span>
            <span class="mat-error custom-mat-error" *ngIf="PublishDate.errors.required">
              Publish Date is required
            </span>event.chipInput
          </div>
        <!-- </mat-form-field> -->
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Publication Link*</div>
        <!-- <mat-form-field> -->
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.hyperlink" name="Link" #Link="ngModel" required="true">
          <div *ngIf="Link.invalid && (Link.dirty || Link.touched)">
            <span class="mat-error custom-mat-error" *ngIf="Link.errors.required">
              Publication link is required
            </span>
            <!-- <span *ngIf="Link.errors.pattern">
              Publication link is not valid
            </span> -->
          </div>
        <!-- </mat-form-field> -->
      </div>
    </div>
  </div>
  
  <div class="row single_import_row">
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Country* </div>
        <!-- <mat-form-field> -->
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.country" [matAutocomplete]="autoCountry" name="country" #country="ngModel"
            required="true" (ngModelChange)="applyFilterOnCountry($event)"
            (keypress)="keyPressAlphaNumeric($event)" maxlength="50" (focus)="selectedCountry()">
          <mat-autocomplete #autoCountry= "matAutocomplete" (optionSelected)="selectedCountry()">
            <mat-option *ngFor="let item of searchedCountries" [value]="item.value">
              {{item.name}}
            </mat-option>
          </mat-autocomplete>
          <div *ngIf="country.invalid && (country.dirty || country.touched)">
            <span class="mat-error custom-mat-error" *ngIf="country.errors.required">
              Country is required
            </span>
          </div>
        <!-- </mat-form-field> -->
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Type *</div>
        <!-- <mat-form-field> -->
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.pubType" name="type" #type="ngModel" required="true" (keypress)="keyPressAlphaNumeric($event)">
          <div *ngIf="type.invalid && (type.dirty || type.touched)">
            <span class="mat-error custom-mat-error" *ngIf="type.errors.required">
              Type is required
            </span>
          </div>
        <!-- </mat-form-field> -->
      </div>
    </div>
    <!-- <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Topic* </div>
        <mat-form-field>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.ruleTopic" [matAutocomplete]="autoRuleTopic" name="topic" #topic="ngModel"
            required="true"  (ngModelChange)="applyFilterOnTopic($event)" (keypress)="keyPressAlphaNumeric($event)">
          <mat-autocomplete #autoRuleTopic="matAutocomplete">
            <mat-option *ngFor="let item of searchedTopics" [value]="item.value">
              {{item.name}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="topic.invalid && (topic.dirty || topic.touched)">
            <span *ngIf="topic.errors.required">
              Topic is required
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </div> -->
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Topic *</div>
       
        <!-- <mat-form-field > -->
          <mat-chip-grid #topicList>
            <ng-container *ngFor="let topic of RuleTopic">
              <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeTopic(topic)">
                {{topic}}
                <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
              </mat-chip-row>
            </ng-container>
            <input class="form-control form-control-sm mat-autodd-input border-bottom" #ruleTopicInput
              [formControl]="searchRuleTopicFormControl" [matAutocomplete]="ruleTopicAutocomplete" [matChipInputFor]="topicList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="addTopic($event)" (keypress)="keyPressAlphaNumericRule($event)"  required>
          </mat-chip-grid> 
          <mat-autocomplete #ruleTopicAutocomplete="matAutocomplete" (optionSelected)="selectedTopicEvent($event)">
            <mat-option *ngFor="let topic of searchedTopics" [title]="topic.name" [value]="topic.value">
              {{topic.name}}
            </mat-option>
          </mat-autocomplete>
          <!-- <span>
            {{isRuleValid}}
          </span> -->
          <!-- <mat-error *ngIf="searchRuleTopicFormControl.errors?.required">
            Topic is required
          </mat-error> -->
        <!-- </mat-form-field> -->
        <span *ngIf="!isRuleValid" class="mat-error custom-mat-error">
            Topic is required
        </span>
      </div>
    </div>
  </div>
  
  <div class="row single_import_row">
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Regulator* </div>
        <!-- <mat-form-field> -->
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.regulator"  [matAutocomplete]="autoRegulator" name="regulator" #regulator="ngModel"
            required="true" (ngModelChange)="applyFilterOnRegulator($event)" 
            (keypress)="keyPressAlphaNumeric($event)" maxlength="100" (optionSelected)="selectedRegulator()">
          <mat-autocomplete #autoRegulator="matAutocomplete" (optionSelected)="selectedRegulatorEvent($event)">
            <mat-option *ngFor="let item of searchedRegulators" [value]="item.value">
              {{item.name}}
            </mat-option>
          </mat-autocomplete>
          <div *ngIf="regulator.invalid && (regulator.dirty || regulator.touched)">
            <span class="mat-error custom-mat-error" *ngIf="regulator.errors.required">
              Regulator is required
            </span>
          </div>
        <!-- </mat-form-field> -->
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Title *</div>
        <!-- <mat-form-field> -->
          <input class="form-control form-control-sm mat-autodd-input border-bottom" type="text" matInput
            [(ngModel)]="InputModel.title" name="title" #title="ngModel" required="true">
          <mat-error *ngIf="title.invalid && (title.dirty || title.touched)">
            <span class="mat-error custom-mat-error" *ngIf="title.errors.required">
              Title is required
            </span>
          </mat-error>
        <!-- </mat-form-field> -->
      </div>
    </div>
  </div>
  <div class="row single_import_row">
    <div class="col-lg-12">
      <div class="form-group">
        <div class="left inline control-label mb-1">Description *</div>
        <mat-form-field class="textarea_field w-100">
          <textarea matInput (keyup)="autoGrow()" #textArea [(ngModel)]="InputModel.description" name="desc" #desc="ngModel" required="true">
          </textarea>
          <mat-error class="pl-0" *ngIf="desc.invalid && (desc.dirty || desc.touched)">
            <span class="mat-error custom-mat-error" *ngIf="desc.errors.required">
              Description is required
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
